import { MaintenanceState, MaintenanceStateInfo } from '@mp/system/maintenance/domain';

/**
 * Returns the timestamp at which the maintenance state changes according to the known window.
 *
 * An announced window transitions at its start, a running window at its end. Without a disclosed window
 * there is nothing to transition to.
 * @param stateInfo The last known maintenance state.
 * @returns The UTC timestamp of the next transition or `null` when no transition is known.
 */
export function nextTransitionTimestamp(stateInfo: MaintenanceStateInfo): string | null {
  switch (stateInfo.state) {
    case MaintenanceState.Announced:
      return stateInfo.startUtc;

    case MaintenanceState.Active:
      return stateInfo.endUtc;

    default:
      return null;
  }
}
